// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__2f1ox","table":"Market_table__2kUq5","row":"Market_row__2Bms-","col":"Market_col__2sy6X","foot":"Market_foot__3pVsb","arrow":"Market_arrow__1f5X0"};